export const processFilterOptions = (options, searchFieldValue) =>
    options
        ? options
              .filter(
                  (option) =>
                      searchFieldValue === '' ||
                      option.label
                          .toLowerCase()
                          .includes(searchFieldValue.toLowerCase())
              )
              .sort((a, b) => a.label.localeCompare(b.label))
              .reduce(
                  (acc, curr) =>
                      curr.label.toLowerCase() === 'all'
                          ? [curr, ...acc]
                          : [...acc, curr],
                  []
              )
        : [];

/**
 * Takes in an object containing all filter values and checks that
 * all values are numbers
 * @param {Object} filterValues params object containing request params
 * @param {Number} filterValues.startMonth
 * @param {Number} filterValues.endMonth
 * @param {Number} filterValues.zone
 * @param {Number} filterValues.market
 * @param {Number} filterValues.team
 * @param {Number} filterValues.rm
 * @returns {Boolean}
 */
export const areAllFilterValuesNumberValues = (filterValues) => {
    const { zone, market, team, rm, startMonth, endMonth } = filterValues;
    return (
        typeof zone === 'number' &&
        typeof market === 'number' &&
        typeof team === 'number' &&
        typeof rm === 'number' &&
        typeof startMonth === 'number' &&
        typeof endMonth === 'number'
    );
};
